// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2026project/q1/2026sports/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const save = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save`, qsData);
};

const getVoteList = (page: number, search: string, workType: number = 1) => {
  return http.get(
    `${urlPrefix}vote-list&page=${page}&search=${search}&workType=${workType}`,
  );
};

const getDetail = (id: any) => {
  return http.get(`${urlPrefix}detail&id=${id}`);
};

const getVoteListReview = (page: number, search: string) => {
  return http.get(`${urlPrefix}vote-list-back&page=${page}&search=${search}`);
};

const getDetailReview = (id: any) => {
  return http.get(`${urlPrefix}detail-back&id=${id}`);
};

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

const getUser = (data: any) => {
  const qsData = qs.stringify(data);
  return http.get(`${urlPrefix}user-list&${qsData}`);
};

const ifSave = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}if-save`, qsData);
};

const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

export {
  getNews,
  getBaseInfo,
  getVoteList,
  getDetail,
  getVoteListReview,
  getDetailReview,
  save,
  getUser,
  ifSave,
  getRule,
};
